<template>
  <form @submit.prevent="onSubmit">
    <div class="form-row align-items-center">
      <div class="col-auto">
        <label class="sr-only" for="name">Название</label>
        <input
            class="form-control mb-2"
            id="name"
            v-model="local.name"
            type="text"
            placeholder="Название"
            required
        >
      </div>
      <div class="col-auto" v-if="local.id === '' && accounts">
        <label class="sr-only" for="category">Счет</label>
        <select
            id="category"
            class="form-control mb-2 form-select"
            v-model="local.accountId"
            required
        >
          <option
              v-for="acc in accounts"
              :key="acc.id"
              :value="acc.id"
              :selected="local.accountId === acc.id"
          >
            {{ acc.name }}
          </option>
        </select>
      </div>
      <div class="col-auto">
        <label class="sr-only" for="amount">Лимит</label>
        <input
            class="form-control"
            v-model.number="local.amount"
            ref="amountRef"
            placeholder="1000"
            inputmode="decimal"
            required
        >
      </div>
      <div class="col-auto" v-if="local.id === ''">
        <label class="sr-only" for="type">Тип</label>
        <select
            id="type"
            class="form-control mb-2 form-select"
            v-model="local.type"
            required
        >
          <option
              v-for="t in types"
              :key="t.id"
              :value="t.id"
              :selected="local.type === t.id"
          >
            {{ t.name }}
          </option>
        </select>
      </div>
      <div class="col-auto" v-if="scopeTypes">
        <label class="sr-only" for="scopeType">Учет транзакций</label>
        <select
            id="scopeType"
            class="form-control mb-2 form-select"
            v-model="local.scopeType"
            required
        >
          <option
              v-for="t in scopeTypes"
              :key="t.id"
              :value="t.id"
              :selected="local.scopeType === t.value"
          >
            {{ t.name }}
          </option>
        </select>
      </div>
      <div class="col-auto">
        <label class="sr-only" for="dateFrom">Дата от</label>
        <input
            id="dateFrom"
            class="form-control mb-2"
            type="datetime-local"
            v-model="local.dateFrom"
            required
        />
      </div>
      <div class="col-auto">
        <label class="sr-only" for="dateTo">Дата до</label>
        <input
            id="dateTo"
            class="form-control mb-2"
            type="datetime-local"
            v-model="local.dateTo"
            required
        />
      </div>
      <div class="text-danger g-3 mt-3 d-flex justify-content-center align-items-center" v-if="props.errorMessage">
        <span>{{ props.errorMessage }}</span>
      </div>
      <div class="col-auto g-3 mt-3">
        <button class="btn btn-primary mb-2" type="submit">
          Сохранить
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>
import {onMounted, reactive, ref, watch} from 'vue';
import {toLocalInputValue, nowLocal, normalizeAmountInput} from '@/api/helpers';
import {getScopeTypes, getTypes} from "@/features/plans/composables/usePlan";

const props = defineProps({
  accounts: { type: Array, required: false },
  initial: {type: Object, required: false },
  errorMessage: {type: String, required: false },
});
const local = reactive({
  id: props.initial?.id ?? '',
  name: props.initial?.name ?? '',
  accountId: props.initial?.accountId ?? '',
  amount: props.initial?.amount != null ? Math.abs(props.initial.amount) : '',
  type: props.initial?.type ?? '',
  scopeType: props.initial?.scopeType ?? '',
  dateFrom: (props.initial?.dateFrom ? toLocalInputValue(props.initial?.dateFrom) : nowLocal()),
  dateTo: (props.initial?.dateTo ? toLocalInputValue(props.initial?.dateTo) : nowLocal()),
});
const emit = defineEmits(['submit']);

const amountRef = ref(null);
onMounted(async () => {
  normalizeAmountInput(amountRef);
});

const types = getTypes();
const scopeTypes = getScopeTypes();

function onSubmit() {
  local.amount = Number(local.amount) || 0.01;
  emit('submit', {...local});
}
</script>
